module.exports = __webpack_public_path__ + "static/media/freeBodyPulleyProblem1.2ed5a35c.svg";